import React from "react";
import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withFocusable, Loading } from "../../services/visualLibraryService";
import {
  LandingPageStyled,
  LandingContainerStyled,
  LinkStyled,
  ButtonModalStyled,
  LogoStyled,
  PinItemStyled,
  TextStyled,
  PinContainerStyled,
  LineTextStyled,
  LeftBlock,
  RightBlock,
  AlignText,
  StepNumber,
  StepContainer,
  StepText,
  StepTextContainer,
  QRCode,
  PinLoginInfoContainer,
  LoginOptionContainer
} from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { getAppState } from "../../state/index";
import { trackPage, trackEvent } from "../../services/analyticsService";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { generatePin, loginPin } from "../../services/pinLoginService";
import { routes } from "../../routes";
import { autologin } from "../../services/authenticationService";
import { getLoginRedirectionData } from "../../services/navigationService";
// import { getFlavor } from "../../services/flavor";

const PAGE = "pinLogin";
const ButtonModalFocus = withFocusable(ButtonModalStyled);
const joinFocusPath = "joinVoucherModal_passThru";
const loginFocusPath = "loginVoucherModal_passThru";
// const flavor = getFlavor();

class PinLoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pin: "",
      isLoading: true,
      timer: null
    };
    this.onBack = this.onBack.bind(this);
    this.enterHandler = this.enterHandler.bind(this);
  }

  async getPin() {
    const pinResponse = await generatePin();
    this.setState({ pin: pinResponse.pin });
  }

  componentDidMount() {
    this.props.onRef && this.props.onRef(this);
    (async () => {
      await this.getPin().then(() => {
        this.setState({ isLoading: false });
      });

      let { navigationMode, redirectPath } = getLoginRedirectionData.call(this);
      this.timer = setInterval(async () => {
        try {
          const { stateActions, history } = this.props;
          const loginPinResponse = await loginPin({ pin: this.state.pin });
          if (loginPinResponse.errorCode === 4009) {
            await this.getPin();
          } else if (loginPinResponse.webToken && loginPinResponse.webToken !== "false") {
            clearInterval(this.state.timer);
            localStorage.setItem("userJWT", loginPinResponse.webToken);
            const data = await autologin();
            stateActions.userLoggedIn(data);
              redirectPath === "/login" ||  redirectPath === "/player"
                ? redirectTo.call(this, routes.home, historyMethods.REPLACE)
                : history[navigationMode](redirectPath);
          }
        } catch (error) {
          console.log(error);
        }
      }, 5000);
    })();
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  enterHandler(eventAction, path, locationData) {
    // trackEvent(SIGNUP, eventAction);
    redirectTo.call(this, path, locationData, historyMethods.REPLACE);
  }

  onBack() {
    redirectTo.call(this, routes.home, null, historyMethods.REPLACE);
    return true;
  }

  render() {
    const {
      applicationState: { userLocale }
    } = this.props;
    return (
      <LandingPageStyled
        background={`https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/images/pinscreen/linktv/background_pinscreen.jpg`}
      >
        {this.state.isLoading && <Loading overlay />}
        <PinLoginInfoContainer>
          <LeftBlock userLocale={userLocale}>
            <LandingContainerStyled>
              <TextStyled rank="1" text={i18n.get("pages.pinLogin.heading")} size="large" />
              <StepContainer>
                <StepNumber>1</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.pinLogin.step1")} size="medium" />
                  <LinkStyled rank="2">{i18n.get("pages.pinLogin.url")}</LinkStyled>
                </StepTextContainer>
              </StepContainer>
              <StepContainer>
                <StepNumber>2</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.pinLogin.step2")} size="medium" />
                </StepTextContainer>
              </StepContainer>
              <StepContainer>
                <StepNumber>3</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.pinLogin.step3")} size="medium" />
                  <PinContainerStyled locale={i18n.getLocale()}>
                    {this.state.pin.split("").map((v, i) => (
                      <PinItemStyled key={`pin-${i}-${v}`}>{v}</PinItemStyled>
                    ))}
                  </PinContainerStyled>
                </StepTextContainer>
              </StepContainer>
            </LandingContainerStyled>
          </LeftBlock>
          <RightBlock userLocale={userLocale}>
            <AlignText>
              <LogoStyled />
            </AlignText>
            <QRCode
              src={`https://ev-cdn-lb.shoq.com.pk/prd-peg-data/default/images/qrcodes/linktv-en.png`}
              alt="QR-Code"
            />
          </RightBlock>
        </PinLoginInfoContainer>
        <LoginOptionContainer style={{ display: "flex", flexDirection: "column" }}>
          <LineTextStyled>{i18n.get("pages.pinLogin.or")}</LineTextStyled>

          <ButtonModalFocus
            label={i18n.get("pages.pinLogin.loginButton")}
            focusPath={joinFocusPath}
            onEnterPress={() => this.enterHandler("login_user_selects_passwordlogin", routes.login)}
            onMouseUp={() => this.enterHandler("login_user_selects_passwordlogin", routes.login)}
            size="medium"
            dataSnUp={""}
            dataSnDown={`@${loginFocusPath}`}
            dataSnLeft={""}
            dataSnRight={""}
          />
        </LoginOptionContainer>
      </LandingPageStyled>
    );
  }
}

export default withAppState(withSubtheme(PinLoginPage));
